export const semanticTokens = {
	colors: {
		brand: {
			primary: {
				solid: { value: '{colors.brand.primary.500}' },
			},
			secondary: {
				solid: { value: '{colors.brand.secondary.500}' },
			},
		},
	},
};
